export const PROFILE = {
  name: "Manpreet Singh Bhatti",
  firstName: "Manpreet Singh",
  lastName: "Bhatti",
  title: "Advocate",
  firm: "MS Bhatti & Associates",
  firmTag: "Law Firm",
  court: "Punjab & Haryana High Court",
  practice: "Criminal Litigation",
  phoneDisplay: "098885 55041",
  phoneTel: "+919888555041",
  whatsapp: "https://wa.me/919888555041",
  email: "contact@msbhatti.in",
  rating: "5.0",
  reviews: "72",
  experience: "10+",
  hours: "10:00 AM — 8:00 PM · Mon – Sat",
  address: {
    line1: "Seat No. 83, Room No. 28",
    line2: "New Bar Complex, Punjab & Haryana High Court",
    line3: "Capitol Complex, Sector 1, Chandigarh — 160001",
  },
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Punjab+and+Haryana+High+Court+New+Bar+Complex+Sector+1+Chandigarh",
  reviewUrl: "https://g.page/r/CYNLz--29F1VEBM/review",
  googleListingUrl: "https://www.google.com/maps?cid=6151341732602530691",
  instagram: "https://www.instagram.com/adv__bhatti/",
  facebook: "https://www.facebook.com/advmsbhatti",
  twitter: "https://twitter.com/msbhatti94",
};

// Add case highlights here as objects.
export const CASE_HIGHLIGHTS = [
  {
    type: "Regular Bail Granted",
    ref: "CRM-M-28753-2025",
    court: "Punjab & Haryana High Court",
    year: "2025",
    offence: "Sec. 302 / 120-B IPC",
    note: "Regular bail secured for the accused in a murder case during the pendency of trial.",
  },
  {
    type: "NDPS Bail Granted",
    ref: "CRM-M-34593-2025",
    court: "Punjab & Haryana High Court",
    year: "2025",
    offence: "Sec. 21 & 29, NDPS Act",
    note: "Regular bail allowed in a narcotics prosecution before the High Court.",
  },
  {
    type: "FIR Quashed",
    ref: "CRM-M-29002-2026",
    court: "Punjab & Haryana High Court",
    year: "2026",
    offence: "Sec. 108, BNS 2023",
    note: "FIR taken up for quashing on the basis of a compromise between the parties.",
  },
  {
    type: "Sentence Suspended",
    ref: "CRM-2333-2025",
    court: "Punjab & Haryana High Court",
    year: "2025",
    offence: "Criminal Appeal",
    note: "Suspension of sentence and release on bail secured pending the criminal appeal.",
  },
  {
    type: "Interim Bail Secured",
    ref: "CRM-M-62757-2025",
    court: "Punjab & Haryana High Court",
    year: "2025",
    offence: "Quashing Petition",
    note: "Interim relief and bail obtained in a petition challenging cancellation of bail.",
  },
  {
    type: "Relief in NDPS Matter",
    ref: "CRM-M-39519-2026",
    court: "Punjab & Haryana High Court",
    year: "2026",
    offence: "Sec. 18/61/85, NDPS Act",
    note: "Directions secured for expeditious consideration of the accused's bail application.",
  },
  {
    type: "Anticipatory Bail Granted",
    ref: "CRM-M-60327-2025",
    court: "Punjab & Haryana High Court",
    year: "2025",
    offence: "Sec. 318(4)/336/338 BNS",
    note: "Interim anticipatory bail secured, protecting the petitioner while joining investigation.",
  },
  {
    type: "Regular Bail Granted",
    ref: "CRM-M-37449-2025",
    court: "Punjab & Haryana High Court",
    year: "2025",
    offence: "Sec. 109 BNS / Sec. 25 Arms Act",
    note: "Regular bail allowed in an Arms Act matter on furnishing bonds.",
  },
  {
    type: "Relief in Criminal Appeal",
    ref: "CRA-D-1418-2025",
    court: "Punjab & Haryana High Court",
    year: "2025",
    offence: "Criminal Appeal",
    note: "Recovery of fine stayed during the pendency of the appeal.",
  },
];

export const PILLARS = [
  {
    no: "01",
    title: "Criminal Litigation",
    desc: "Anticipatory & regular bail, quashing of FIRs, criminal appeals and revisions — handled with urgency, discretion and an unwavering command of procedure.",
    tags: ["Anticipatory Bail", "Regular Bail", "Quashing of FIR", "Appeals & Revisions"],
  },
  {
    no: "02",
    title: "NDPS Matters",
    desc: "Defence in narcotics prosecutions — bail under the twin conditions of Section 37 NDPS, trial strategy and appeals argued with technical rigour.",
    tags: ["Section 37 Bail", "Trial Defence", "Recovery & Search", "Appeals"],
  },
  {
    no: "03",
    title: "Family Disputes (Criminal)",
    desc: "The criminal side of matrimonial conflict — Section 498A, domestic violence, dowry harassment and maintenance — handled with sensitivity and resolve.",
    tags: ["Section 498A", "Domestic Violence", "Dowry Harassment", "Maintenance"],
  },
];

export const SERVICES = [
  "Anticipatory Bail",
  "Regular Bail",
  "Quashing of FIR",
  "Criminal Appeals & Revisions",
  "NDPS Defence",
  "Bail under Section 37 NDPS",
  "Section 498A / Domestic Violence",
  "Maintenance & Dowry Matters",
];

export const MANIFESTO = [
  {
    no: "01",
    title: "The client comes first — always.",
    body: "Every brief begins with listening. We translate anxiety into strategy, and legal jargon into clarity you can act on.",
  },
  {
    no: "02",
    title: "Preparation wins cases.",
    body: "Meticulous research and airtight paperwork, filed precisely as statutory requirements demand, leave nothing to chance in the courtroom.",
  },
  {
    no: "03",
    title: "Transparency at every stage.",
    body: "You are kept informed at each hearing and milestone. No surprises, no hidden costs — only honest counsel and steady progress.",
  },
  {
    no: "04",
    title: "Justice, pursued relentlessly.",
    body: "From the High Court to the trial court, we fight with dedication and an optimistic resolve until your matter reaches its rightful conclusion.",
  },
];

export const REVIEWS = [
  {
    quote:
      "I am extremely grateful to Adv. M.S. Bhatti for his dedication and exceptional efforts in my case. The Court granted me bail in an NDPS matter — his commitment and preparation made all the difference.",
    name: "Pooja Rajput",
    matter: "NDPS — Bail Granted",
  },
  {
    quote:
      "I am deeply grateful to Adv. M.S. Bhatti for his support and involvement in my son's passport proceedings. The process was complex, but he handled every step with patience and professionalism.",
    name: "Sangeeta Bisht",
    matter: "High Court Matter",
  },
  {
    quote:
      "I want to thank Adv. Manpreet Bhatti for the time and involvement he gave my case. His legal expertise, preparation and confidence in court were impressive, and he explained everything clearly at each step.",
    name: "Bhumika",
    matter: "Criminal Litigation",
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1551270029-4bc0f7eabf78?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  portrait:
    "https://customer-assets-lqy194kg.emergentagent.net/job_chandigarh-lawyer/artifacts/bgjxkgh5_IMG_0162.webp",
  justice:
    "https://images.unsplash.com/photo-1589994965851-a8f479c573a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  books: "https://images.pexels.com/photos/159832/justice-law-case-hearing-159832.jpeg?auto=compress&cs=tinysrgb&w=1400",
};
